import { List, ListItem, makeSelectable } from 'material-ui/List';
import { blue700, green700, orange700, red700 } from 'material-ui/styles/colors';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import AcceptedIcon from 'material-ui/svg-icons/action/done';
import ListIcon from 'material-ui/svg-icons/action/list';
import BanIcon from 'material-ui/svg-icons/av/not-interested';
import OpenFolderIcon from 'material-ui/svg-icons/file/folder-open';
import Toggle from 'material-ui/Toggle';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import Details from 'src/components/operatingtool/details';
import TaskList from 'src/components/taskadministration/task-list';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { Entities } from 'src/common/index';
import { withTranslation } from 'react-i18next';
import MapsNavigationIcon from 'material-ui/svg-icons/maps/navigation';
import OperatingToolIcon from 'material-ui/svg-icons/action/date-range';

let SelectableList = makeSelectable(List);

/**
 * Offer Administration displays all available offers
 * with details to the selected one
 */
class OfferAdministration extends Component {
    constructor(props) {
        const { t } = props;
        super(props);
        autoBind(this);

        this.state = {
            filter: 'OPEN_OFFER',
            tableTitle: t('offers.open_offers'),
            showExpiredTasks: false,
        };
    }

    componentDidMount() {
        const { selectedCompany } = this.props;
        this.props.setFetchMethodOnError(this.fetchOnError);
        this.props.fetchByCompanyId(Entities.BUS, selectedCompany);
        this.props.fetchOwnBusCompany(selectedCompany);
        this.props.fetchCompanyOwnedBookingIntegrations();
        this.props.fetchOffersByFilter(selectedCompany, false, this.state.filter);
    }

    componentDidUpdate(prevProps) {
        const { selectedCompany, tasks } = this.props;
        if (tasks.action.type === 'UPDATE') {
            this.props.fetchOffersByFilter(selectedCompany, false, this.state.filter);
        }
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.modal.open;
    }

    render() {
        const { selectedCompany, busCompany, t, integration } = this.props;
        const hasSingleCompanyBookingIntegration =
            integration.items && integration.items.length > 0
                ? integration.items.some(item => item.allCompanies === false)
                : false;

        const hasBookOrRequestOfferOptionAtCheckout = integration.items.some(
            item => item.settings.booking.enableBookOrRequestOfferOptionAtCheckout,
        );

        return (
            <div>
                <div className="row">
                    <div className="col-md-2 sidebar-listview">
                        <div>
                            <Toggle
                                label={t('offers.past')}
                                toggled={this.state.showExpiredTasks === true}
                                onToggle={() => {
                                    this.setState({
                                        showExpiredTasks: !this.state.showExpiredTasks,
                                    });
                                    this.props.fetchOffersByFilter(
                                        selectedCompany,
                                        !this.state.showExpiredTasks,
                                        this.state.filter,
                                    );
                                }}
                            />
                        </div>
                        <SelectableList
                            selectedItemStyle={{
                                backgroundColor: '#0a71ba1a',
                            }}
                            value={this.state.filter}
                            onChange={() => this}>
                            <ListItem
                                className="styled-list-item"
                                key={0}
                                value="OPEN_OFFER"
                                primaryText={t('offers.open')}
                                leftIcon={<OpenFolderIcon color={blue700} />}
                                onClick={() => this.changeFilter('OPEN_OFFER', t('offers.open_offers'))}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={1}
                                value="ACCEPTED_OFFER"
                                primaryText={t('offers.accepted')}
                                leftIcon={<AcceptedIcon color={green700} />}
                                onClick={() => this.changeFilter('ACCEPTED_OFFER', t('offers.accepted_offers'))}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={2}
                                value="DECLINED_OFFER"
                                primaryText={t('offers.declined')}
                                leftIcon={<BanIcon color={orange700} />}
                                onClick={() => this.changeFilter('DECLINED_OFFER', t('offers.declined_offers'))}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={3}
                                value="DELETED_OFFER"
                                primaryText={t('offers.deleted')}
                                leftIcon={<DeleteIcon color={red700} />}
                                onClick={() => this.changeFilter('DELETED_OFFER', t('offers.deleted_offers'))}
                            />
                            <ListItem
                                className="styled-list-item"
                                key={3}
                                value="ALL_OFFERS"
                                primaryText={t('common_phrases.all')}
                                leftIcon={<ListIcon color={blue700} />}
                                onClick={() => this.changeFilter('ALL_OFFERS', t('offers.all_offers'))}
                            />
                        </SelectableList>

                        {busCompany.entity && busCompany.entity.emailToRouteStoreModuleActive && (
                            <div className="voffset40">
                                <legend className="legend" style={{ marginBottom: 0 }}>
                                    {t('offers.features')}
                                </legend>
                                <SelectableList
                                    selectedItemStyle={{
                                        backgroundColor: '#0a71ba1a',
                                    }}
                                    value={1}
                                    onChange={() => this}>
                                    <ListItem
                                        className="styled-list-item"
                                        key={16}
                                        value={16}
                                        primaryText={t('email_to_journey.menu')}
                                        leftIcon={<MapsNavigationIcon color={blue700} />}
                                        onClick={() => this.props.router.push('/email-to-offer')}
                                    />
                                </SelectableList>
                            </div>
                        )}
                        {hasSingleCompanyBookingIntegration && (
                            <div className="voffset40">
                                <legend className="legend" style={{ marginBottom: 0 }}>
                                    {t('booked_tasks.integrations')}
                                </legend>
                                <SelectableList
                                    selectedItemStyle={{
                                        backgroundColor: '#0a71ba1a',
                                    }}
                                    value={1}
                                    onChange={() => this}>
                                    <ListItem
                                        className="styled-list-item"
                                        key={17}
                                        value={17}
                                        primaryText={t('find_my_bus.title')}
                                        leftIcon={<OperatingToolIcon color={blue700} />}
                                        onClick={() => this.props.router.push('/find-my-bus')}
                                    />
                                    <ListItem
                                        className="styled-list-item"
                                        key={17}
                                        value={17}
                                        primaryText={t('offer_printed_customer.title')}
                                        leftIcon={<OperatingToolIcon color={blue700} />}
                                        onClick={() => this.props.router.push('/offer-printed-customer')}
                                    />
                                    {hasBookOrRequestOfferOptionAtCheckout && (
                                        <ListItem
                                            className="styled-list-item"
                                            key={17}
                                            value={17}
                                            primaryText={t('offer_requested_customer.requests')}
                                            leftIcon={<OperatingToolIcon color={blue700} />}
                                            onClick={() => this.props.router.push('/offer-requested-customer')}
                                        />
                                    )}
                                </SelectableList>
                            </div>
                        )}
                    </div>

                    <div id="offer-tasklist-panel" className="col-md-10">
                        <legend className="legend">{this.state.tableTitle}</legend>

                        <TaskList
                            t={t}
                            isOfferView={true}
                            showExpiredTasks={this.state.showExpiredTasks}
                            taskFilter={this.state.filter}
                            selectedCompany={this.props.selectedCompany}
                            tasks={this.props.tasks}
                            buses={this.props.buses}
                            busCompany={this.props.busCompany}
                            selectEvent={this.props.selectEvent}
                            patch={this.props.patch}
                            deleteById={this.props.deleteById}
                            addNotification={this.props.addNotification}
                            openModal={this.props.openModal}
                        />

                        <div className="row">
                            <div className="col-md-12 details-container">
                                <Details
                                    eventDetails={this.props.eventDetails}
                                    busCompany={this.props.busCompany}
                                    patch={this.props.patch}
                                    deleteById={this.props.deleteById}
                                    addNotification={this.props.addNotification}
                                    openModal={this.props.openModal}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    changeFilter(filter, title) {
        const { selectedCompany } = this.props;

        this.props.fetchOffersByFilter(selectedCompany, this.state.showExpiredTasks, filter);
        this.setState({
            filter: filter,
            tableTitle: title,
        });
    }

    fetchOnError() {
        this.props.fetchOffersByFilter(this.props.selectedCompany, this.state.showExpiredTasks, this.state.filter);
    }
}

export default withTranslation()(composeModalActions(OfferAdministration));
